import {
  Button,
  Modal,
  ModalBody,
  ModalContent,
  ModalHeader,
} from "@nextui-org/react";
import { AppParamsContext } from "contexts/AppParamsContext";
import { useContext } from "react";

function PopUpWindow(props) {
  const { isOpen, setIsOpen } = props;
  const { appParams } = useContext(AppParamsContext);
  return (
    <>
      <Modal
        isOpen={isOpen}
        onOpenChange={() => setIsOpen(!isOpen)}
        size=""
        hideCloseButton
        classNames={{
          base: "m-0 max-w-[760px]",
          closeButton:
            "z-50 bg-[var(--button-bg-color)] text-[var(--button-text-color)]",
        }}
      >
        <ModalContent>
          {(onClose) => (
            <>
              <ModalHeader className="flex flex-col gap-1 w-full text-center">
                {appParams?.popUpWindow?.title}
              </ModalHeader>
              <ModalBody>
                <div className="w-full text-center">
                  {appParams?.popUpWindow?.desc}
                </div>
                <Button
                  className="flex"
                  color="primary"
                  onPress={() => setIsOpen(false)}
                  size="lg"
                >
                  {appParams?.popUpWindow?.buttonText}
                </Button>
              </ModalBody>
            </>
          )}
        </ModalContent>
      </Modal>
    </>
  );
}
export default PopUpWindow;
